import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

// Angular Material imports
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

// Shared Components
import { SharedComponent } from './shared.component';
import { BoxViewComponent } from './box-view/box-view.component';
import { ImageSliderComponent } from './image-slider/image-slider.component';
import { CounterComponent } from './counter/counter.component';
import { StyleViewComponent } from './style-view/style-view.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { SeriesHeaderComponent } from './series-header/series-header.component';
import { ReadMoreComponent } from './read-more/read-more.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { MetricViewComponent } from './metric-view/metric-view.component';
import { JournalHeaderComponent } from './journal-header/journal-header.component';
import { JournalCitationComponent } from './journal-citation/journal-citation.component';
import { ImageWithLoaderComponent } from './image-with-loader/image-with-loader.component';
import { ImageCarouselComponent } from './image-carousel/image-carousel.component';
import { HandleUrlComponent } from './handle-url/handle-url.component';
import { CountdownViewComponent } from './countdown-view/countdown-view.component';
import { PdfViewerComponent } from './pdf-viewer/pdf-viewer.component';
import { BookHeaderComponent } from './book-header/book-header.component';
import { AuthorViewComponent } from './author-view/author-view.component';
import { AuthorContentViewComponent } from './author-content-view/author-content-view.component';
import { ArticleViewComponent } from './article-view/article-view.component';
import { HeaderControlsComponent } from './header-controls/header-controls.component';
import { ChapterViewComponent } from './chapter-view/chapter-view.component';
import { AnnouncementViewComponent } from './announcement-view/announcement-view.component';
import { MainHeaderComponent } from './main-header/main-header.component';
import { SimpleLayoutComponent } from './simple-layout/simple-layout.component';

@NgModule({
  declarations: [
    SharedComponent,
    BoxViewComponent,
    ImageSliderComponent,
    CounterComponent,
    StyleViewComponent,
    BreadcrumbComponent,
    SeriesHeaderComponent,
    ReadMoreComponent,
    PageHeaderComponent,
    MetricViewComponent,
    JournalHeaderComponent,
    JournalCitationComponent,
    ImageWithLoaderComponent,
    ImageCarouselComponent,
    HandleUrlComponent,
    CountdownViewComponent,
    BookHeaderComponent,
    AuthorViewComponent,
    AuthorContentViewComponent,
    ArticleViewComponent,
    ChapterViewComponent,
    AnnouncementViewComponent,
    HeaderControlsComponent,
    MainHeaderComponent,
    SimpleLayoutComponent,
    PdfViewerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslatePipe,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    NgOptimizedImage
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    SharedComponent,
    BoxViewComponent,
    ImageSliderComponent,
    CounterComponent,
    StyleViewComponent,
    BreadcrumbComponent,
    SeriesHeaderComponent,
    ReadMoreComponent,
    PageHeaderComponent,
    MetricViewComponent,
    JournalHeaderComponent,
    JournalCitationComponent,
    ImageWithLoaderComponent,
    ImageCarouselComponent,
    HandleUrlComponent,
    CountdownViewComponent,
    BookHeaderComponent,
    AuthorViewComponent,
    AuthorContentViewComponent,
    ArticleViewComponent,
    ChapterViewComponent,
    AnnouncementViewComponent,
    HeaderControlsComponent,
    MainHeaderComponent,
    SimpleLayoutComponent,
    PdfViewerComponent,
    // Material modules exports
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    NgOptimizedImage
  ]
})
export class SharedModule { }
